import React, { useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import CreateFluidIntakeForm from "../templates/CreateFluidIntakeForm";

interface Ref {
  show: () => void;
}

const CreateFluidIntakeModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => {
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Fluid Intake"
      hasCancelButton
    >
      <CreateFluidIntakeForm onClose={handleClose} />
    </ReusableModal>
  );
});

CreateFluidIntakeModal.displayName = "CreateFluidIntakeModal";
export { CreateFluidIntakeModal };
